<template>
  <delassesLoader v-show="Deleteloader"></delassesLoader>
  <div class="modal" id="deltModal" tabindex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header  danger">
          <h5 class="modal-title" id="deleteLabel"> {{ headername }}</h5>
          <div class="close-container myfaBtn" data-bs-dismiss="modal" aria-label="Close">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body {{TClrs}} modal-bodyHt mdclr">
          <div class="row">
            <label class="col-sm-12 nopadding">
              Are you sure that you want to delete Assessment ?
              <br />
              <small>This action cannot be reversed.</small>
            </label>
          </div>
        </div>
        <div class="modal-footer footbdr">
          <div class="effect btn-delete eff-md fbtn" v-show="isDeleteModal" v-on:click="ok()"
            style="color: #dc3545 !important;">Delete</div>
          <div class="btn stdBtn btn-bordered" data-bs-dismiss="modal" type="button"><b>Cancel</b></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap';
import { useRoute } from 'vue-router';
import delassesLoader from '../components/smallcomp/delloader.vue'
export default {
  name: 'DeleteModal',
  props: {
  },
  components: {
    delassesLoader
  },
  data() {
    return {
      modal: undefined,
      TClrs: "",
      isDeleteModal: true,
      Deleteloader: false,
      headername: ""
    }
  },
  methods: {
    showDeltModal(hdr) {
      this.modal.show()
      this.headername = hdr
    },
    ok() {
      this.isDeleteModal = false
      this.Deleteloader = true
      this.axios.get(this.uriApiUrl + 'UserSetting/del_assessment?AsgId=' + this.asgId,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data == "Success") {
              this.$notify({ type: "success", text: "Assessment Deleted successfully." })
              this.modal.hide()
              this.$router.push({ path: '/' })
            }
            else if (response.data == "Denied") {
              this.$notify({ type: "error", text: "Sorry! You have no access to delete this assessment!" })
              this.modal.hide()
            }
            else {
              this.$notify({ type: "error", text: "Sorry! Could not delete the Assessment.. Try after sometime!" })
              this.modal.hide()
            }
            this.Deleteloader = false
          }
        }).catch((error) => {
          this.$notify({ type: "error", text: "Sorry! Could not delete the Assessment.. Try after sometime!" })
          this.Deleteloader = false
        })
    }
  },
  mounted() {
    this.modal = new Modal(document.getElementById('deltModal'))
    const route = useRoute()
    this.asgId = route.params.asgid
  }
}
</script>
<style scoped>
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>